<template>
  <div class="dashboard container">
    <transition name="fade" mode="out-in">
      <router-view key="dashboard"></router-view>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'Dashboard',
}
</script>

<style scoped>
.card-modal-content {
  position: fixed;
  max-width: 768px;
  margin: 0 auto;
  left: 0;
  right: 0;
}
</style>
